import { ButtonProps, ButtonType, ButtonWidget, TabStyles } from '@tableau/widgets';
import React from 'react';
import { imgPath } from '~common/utilities/ImgUrl';
import { Messages } from '../../codegen/Localize';

//todo jjia: fix aria related stuff

export interface LinkedTaskEditButtonProps {
  isExpanded: boolean;
  setIsExpanded: (expanded: boolean) => void;
}

export function LinkedTaskEditButton(props: LinkedTaskEditButtonProps) {
  const buttonProps: ButtonProps = {
    title: Messages.linkedTasksEditLinkedTask(),
    buttonType: ButtonType.Icon,
    testId: 'linked-task-edit-button',
    style: {
      padding: `${TabStyles.Spacing.SmallSpace}px`,
      marginLeft: `${TabStyles.Spacing.SmallSpace}px`,
    },
    handleClick: () => props.setIsExpanded(!props.isExpanded),
  };
  return (
    <ButtonWidget {...buttonProps} aria-label={Messages.linkedTasksEditLinkedTask()} aria-expanded={props.isExpanded}>
      <img src={imgPath('menu_edit.svg')} alt={Messages.linkedTasksEdit()} />
    </ButtonWidget>
  );
}
